import { render, staticRenderFns } from "./OnlineWaTemplateSelector.vue?vue&type=template&id=53d6cd4c&scoped=true&"
import script from "./OnlineWaTemplateSelector.vue?vue&type=script&lang=js&"
export * from "./OnlineWaTemplateSelector.vue?vue&type=script&lang=js&"
import style0 from "./OnlineWaTemplateSelector.vue?vue&type=style&index=0&id=53d6cd4c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53d6cd4c",
  null
  
)

export default component.exports